import axios from "axios"
import ButtonComponent from "../../../components/ButtonComponent"
import { fontSize_15, fontSize_20, fontSize_32 } from "../../../shared/styleconfig"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"

export const LatestNews = () => {
    const navigate = useNavigate();
    const [latestNews, setLatestNews] = useState([])
    const [loading, setLoading] = useState(false)

    const getTopThreeNews = () => {
        try {
            setLoading(true)
            const apiUrl = 'https://api.thenewsapi.com/v1/news/all?api_token=gIoBF2gHKYmdODFWDzEY7fQdSDQ8EUyJUquGJlQX&language=en&limit=3&categories=business';
            axios.get(apiUrl)
            .then((result) => {
                if(result?.status === 200){
                    const data= [...result?.data?.data];
                    setLatestNews(data?.splice(0, 3));
                }
            })
            .catch((error) => {
                console.log("error",error)
            })
            .finally(() => {
                setLoading(false)
            })
        }
        catch(err) {
            console.log(err)
        }
    }

    useEffect(() => {
        getTopThreeNews()
    }, [])

    return (
        <div className="flex w-[350px] shrink-0 h-[657px] bg-[#001639] rounded-[20px] flex-col no-scrollbar overflow-auto">
            <label className={`${fontSize_32} text-[#FFFFFF50] font-bold px-7 pt-7 pb-4 `}>
                Latest Market News
            </label>

            {loading ? 
                <div className="flex flex-col px-[30px] flex-1 items-center justify-center text-white">
                    Loading News. Please wait...
                </div>
              : (
                <div className="flex flex-col flex-1">
                    <div className="flex flex-col px-[30px] gap-[40px] flex-1">
                        {latestNews.length > 0 && latestNews.map((news, index) => {
                            const commonCSS = `flex flex-col border-b border-b-solid border-b-[#FFFFFF50] pb-[15px]`
                            return (<div className={`${commonCSS} ${index === 0 ? 'border-t border-t-solid border-t-[#FFFFFF50] pt-4' : ''}`}>
                                <div className={`${fontSize_20} text-[#FFFFFF] font-bold leading-[25px] line-clamp-3`}>
                                    {news?.title}
                                </div>
                                <p className={`${fontSize_15} uppercase text-[#0061FC] mt-[10px] font-semibold`}>
                                <a href={news?.url} target='_blank' >Read More</a></p>
                            </div>)
                        })}
                    </div>
                    <ButtonComponent
                        buttontext="See all news"
                        className={`border-[#707070] bg-[#1a60de] text-white w-[160px] mx-[30px] my-[20px]`}
                        onClick={() => {
                            navigate('/learn')
                        }}
                    />
                </div>
              )}
        </div>
    )
}